import { BoxProps, Box } from "@mui/material";

export const SearchContainer = ({ sx, ...props }: BoxProps) => {
  return (
    <Box
      sx={[
        {
          display: "flex",
          alignItems: "center",
          gap: "2.5rem",
          justifyContent: "space-between",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    ></Box>
  );
};
